const minWidths = {
  xs: 0,
  sm: 480,
  md: 768,
  lg: 992,
  xl: 1440,
};

const screenSize = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
};

const screenType = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
};

const browserUtils = {
  minWidths,
  screenSize,
  screenType,
  screen: {
    width(): number | null {
      if (typeof window !== 'undefined') {
        return window.innerWidth && document.documentElement.clientWidth
          ? Math.min(window.innerWidth, document.documentElement.clientWidth)
          : window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      }
      return null;
    },
    size(width = browserUtils.screen.width()): string | null {
      if (width < minWidths.sm) {
        return screenSize.XS;
      } else if (width < minWidths.md) {
        return screenSize.SM;
      } else if (width < minWidths.lg) {
        return screenSize.MD;
      } else if (width < minWidths.xl) {
        return screenSize.LG;
      } else if (width >= minWidths.xl) {
        return screenSize.XL;
      }
      return null;
    },
    type(size = browserUtils.screen.size()): string | null {
      switch (size) {
        case screenSize.XS:
        case screenSize.SM:
        case screenSize.MD:
          return screenType.MOBILE;
        case screenSize.LG:
          return screenType.TABLET;
        case screenSize.XL:
          return screenType.DESKTOP;
        default:
          return null;
      }
    },
  },
};

browserUtils.screen.width = browserUtils.screen.width.bind(browserUtils);
browserUtils.screen.size = browserUtils.screen.size.bind(browserUtils);
browserUtils.screen.type = browserUtils.screen.type.bind(browserUtils);

export default browserUtils;
